import { Observable, of } from "rxjs";
import { CheckRideOwnershipTypeAllItems, CheckrideRequestSchoolCalendarQueryEntity, PilotExaminerEntity } from "../../../meta-data/app-meta-data.service";
import { CalendarDTO } from "../../calendar/models/calendar.model";
import { EventSearchRequestDTO } from "../../calendar/models/event-search-request.model";
import { CalendarControllerService } from "../../calendar/services/interfaces/calendar-controller-service.interface";
import { ScheduleBlockCalendarEvent } from "../../schedule-blocks/models/schedule-block-calendar-event.model";
import { CalendarRepositoryService } from "../../calendar/services/calendar-repository.service";
import { ScheduleBlockService } from "../../schedule-blocks/services/schedule-block.service";
import { DwQueryMetaData } from "@devwareapps/devware-cap";
import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ExaminerRepositoryService } from "../../examiner/services/examiner-repository.service";
import { CheckrideReferenceInfo } from "../../examiner/models/checkride-reschedule-info.model";
import { ScheduleBlockSchoolExaminerOptions } from "../../schedule-blocks/models/schedule-block-school-examiner-options.model";
import { CalendarEventDTO } from "../../calendar/models/calendar-event.model";
import { SchoolRepositoryService } from "./school-repository.service";

@Injectable()
export class SchoolCalendarControllerService implements CalendarControllerService {
    schoolExaminerOptions: ScheduleBlockSchoolExaminerOptions[];

    constructor(protected calendarRepositoryService: CalendarRepositoryService,
        protected examinerRepositoryService: ExaminerRepositoryService,
        protected scheduleBlockService: ScheduleBlockService,
        protected schoolRepositoryService: SchoolRepositoryService
    ) { }
  

    getScheduleBlocks(eventSearchRequest: EventSearchRequestDTO, scheduleBlockId?: number): Observable<ScheduleBlockCalendarEvent[]> {
        return this.scheduleBlockService.getScheduleBlocks({ startDate: eventSearchRequest.StartDateTime, endDate: eventSearchRequest.EndDateTime, scheduleBlockId: scheduleBlockId, ownershipTypeId: this.getOwnershipTypeId() });
    }

    getOwnershipTypeId(): number {
        return CheckRideOwnershipTypeAllItems.FlightSchool;
    }

    getCheckrides(eventSearchRequest: EventSearchRequestDTO, queryMetaData: DwQueryMetaData): Observable<CheckrideRequestSchoolCalendarQueryEntity[]> {
        return this.schoolRepositoryService.getSchoolCheckRides(eventSearchRequest.StartDateTime, eventSearchRequest.EndDateTime);
        //return this.examinerRepositoryService.getCheckRidesRequests(queryMetaData, eventSearchRequest.StartDateTime, eventSearchRequest.EndDateTime);
    }

    useBlockBooking(): boolean {
        return true;
    }

    getCurrentCalendarRef(): Observable<any> {
        return of(null);
    }

    getCalendarMenu(): string {
        return 'school-calendar';
    }

    getCalendars(): Observable<CalendarDTO[]> {
        return of([]);  // this.calendarRepositoryService.getCalendars();
    }

    setCheckrideReferenceInfo(CheckRideRequestId: number, rescheduleInfo: CheckrideReferenceInfo) {
        this.examinerRepositoryService.setCheckrideReferenceInfo(CheckRideRequestId, rescheduleInfo);
    }

    loadSetupData(): Observable<any> {
        const ob = this.scheduleBlockService.getSchoolExaminerOptions()
            .pipe(tap(options => {
                this.schoolExaminerOptions = options;
            }));

        return ob;
    }

    allowCalendarIntegration(): boolean {
        return false;
    }

    getCalendarEvents(request: EventSearchRequestDTO): Observable<CalendarEventDTO[]> {
        return of([]);
    }

    canEditScheduleBlock(scheduleBlock: ScheduleBlockCalendarEvent): boolean {
        return scheduleBlock.CanEdit;
    }

    getEventDisplayOptions() : { showSchool: boolean, showExaminer: boolean } {
        return { showSchool: false, showExaminer: true };
    }
}